/*
    SUMMARY
    0 - AUTO YEAR
    1 - BACK TO TOP
*/


export default function Footer() {

    /*-----------------/ 0 - Const / Variables /--------------------*/
    const backToTopBtn = document.getElementById('backToTopBtn')
    const footer = document.getElementById('footer')

    /*-----------------/ 1 - Function /--------------------*/

    // Back to Top Button Show/Hide
    function toggleBackToTopBtn() {
        if (!footer || !backToTopBtn) return

        const footerRect = footer.getBoundingClientRect()
        const windowHeight = window.innerHeight

        // Show button when footer is visible
        if (footerRect.top <= windowHeight && footerRect.bottom >= 0) {
            backToTopBtn.classList.add('show')
        } else {
            backToTopBtn.classList.remove('show')
        }
    }

    // Scroll to Top Function
    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    /*-----------------/ 2 - AUTO YEAR /--------------------*/
    const currentYear = new Date().getFullYear()
    const yearElement = document.querySelector('.auto--year')
    if (yearElement) {
        yearElement.innerHTML = currentYear
    }

    /*-----------------/ 3 - BACK TO TOP /--------------------*/
    // Add scroll event listener for back to top button
    window.addEventListener('scroll', toggleBackToTopBtn)

    // Add click event listener for back to top button
    if (backToTopBtn) {
        backToTopBtn.addEventListener('click', scrollToTop)
    }

    // Initial check
    toggleBackToTopBtn()
}
